import { Layout } from 'react-admin';
import Bar from './Bar';
import { usePreferences } from "@react-admin/ra-preferences";
import { Menu } from "@react-admin/ra-rbac";

const CustomLayout = props => {
    const [theme] = usePreferences('theme', 'light');
    return <Layout {...props} appBar={Bar} className={theme} menu={Menu} />
};

export default CustomLayout;